var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7718 0L18.331 8.03935L27.5404 7.98584L22.9341 0.025182L13.7718 0Z",
    fill: "#2CABE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5404 7.98584L18.331 8.03935L13.7718 15.9748L22.9341 16L27.5404 7.98584Z",
    fill: "#1E75BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7718 0L18.331 8.03935L13.7718 15.9748L9.1655 8.01416L13.7718 0Z",
    fill: "#293B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60625 15.9465L9.1655 23.989L18.3749 23.9355L13.7718 15.9748L4.60625 15.9465Z",
    fill: "#2CABE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3749 23.9355L9.1655 23.989L4.60625 31.9213L13.7686 31.9497L18.3749 23.9355Z",
    fill: "#1E75BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60625 15.9465L9.1655 23.989L4.60625 31.9213L0 23.9607L4.60625 15.9465Z",
    fill: "#293B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9341 16L27.4934 24.0393L36.7059 23.9858L32.0996 16.0252L22.9341 16Z",
    fill: "#2CABE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7059 23.9858L27.4934 24.0394L22.9341 31.9748L32.0996 32L36.7059 23.9858Z",
    fill: "#1E75BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9341 16L27.4934 24.0393L22.9341 31.9748L18.331 24.0142L22.9341 16Z",
    fill: "#293B8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.7059,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini_logo.68a3f159766e9772ba2aeab80ebb1570.svg";
export { ForwardRef as ReactComponent };